import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state() {
    return {
      supplierOrders: [],
      supplierOrder: {},
      supplierOrderItem: {},
      supplierOrderMetadata: [],
      filters: []
    }
  },
  getters,
  actions,
  mutations
}
